 import React from 'react';

import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { useAuth } from '../../context/AuthContext';



const Card = styled.div`

  max-width: 550px; 

  width: 100%;      

  min-height: 280px; 

  padding: 45px 40px; 

  margin: 40px auto; 

  

  background-color: var(--panel-dark, #161c2d); 

  border-radius: var(--radius, 16px);

  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.7); 

  transition: transform 0.3s ease, box-shadow 0.3s ease; 

  text-align: center; 

  font-family: 'Inter', sans-serif; 

  box-sizing: border-box; 

  color: #e0e0e0; 

`;



const Title = styled.h3`

  font-size: 1.5rem;

  margin-bottom: 1rem;

  color: white;

`;



const FeatureList = styled.ul`

  list-style: none;

  padding: 0;

  margin: 1rem 0 1.5rem;

  text-align: left;

`;



const Feature = styled.li`

  font-size: 1rem;

  margin-bottom: 0.5rem;

  color: white;



  &::before {

    content: '${(props) => (props.$included ? '✔️' : '❌')} ';

    margin-right: 8px;

  }

`;



const TryProButton = styled.button`

  background-color: #ff6f00;

  color: white;

  font-weight: bold;

  border: none;

  padding: 12px 20px;

  border-radius: 8px;

  font-size: 1rem;

  cursor: pointer;

  transition: background-color 0.3s ease;



  &:hover {

    background-color: #e65c00;

  }

`;



// New styled button for renew with yellow background and 15px border radius

const RenewButton = styled(TryProButton)`

  background-color: #ffeb3b;

  color: black;

  border-radius: 15px;

  font-weight: bold;

  padding: 12px 20px;

  cursor: pointer;

  margin-top: 15px;



  &:hover {

    background-color: #ffeb3b;

  }

`;



function ProPlanSelector({ onContinue }) {

  const navigate = useNavigate();

  const { userPlan, currentUser } = useAuth();



  const handleTryPro = () => {
    navigate('/try-pro');
  };



  // Bypass planStatus check for admin user

  const adminEmail = 'seifeddinejamai8@gmail.com';

  return (
    <Card className="pricing-card">
      <img
        id="Pro-Plan-img"
        src="https://d1csarkz8obe9u.cloudfront.net/posterpreviews/vip-logo-design-template-098e8dfa032b844afcec2df88d1ff290_screen.jpg?ts=1738304438"
        alt="Pro VIP"
      />
      <Title>Pro</Title>

      {/* Price added here */}
      <p style={{ color: '#ff6f00', fontSize: '2rem', marginBottom: '1rem' }}>
        €19.99/mois
      </p>

      <ul className="pro-plan-features">
        <li>Accès complet à l'IA</li>
        <li>Support vocal</li>
        <li>Historique illimité</li>
        <li>Exportation rapide</li>
        <li>Support prioritaire</li>
      </ul>

      <br></br>

      {currentUser?.email !== adminEmail &&
      userPlan?.planId &&
      (userPlan.planStatus === 'expired' || userPlan.planStatus === 'inactive') ? (
        <>
          <Title>Plan Expired</Title>
          <p>Your subscription plan has expired. Please renew to access Pro features.</p>
          <RenewButton onClick={() => navigate('/try-pro')}>
            Renew Pro Plan
          </RenewButton>
        </>
      ) : (
        <TryProButton onClick={handleTryPro}>Essayez Pro</TryProButton>
      )}
    </Card>
  );

}

export default ProPlanSelector;